import { Tabs } from 'components/shared/Tabs';

import { ITINERARIES_ITEM_TYPES } from '../../../../../../constants';
import { CopyLink } from './CopyLink';
import s from './index.module.css';
import { ShareViaEmail } from './ShareViaEmail';

export type ContentProps = {
  builder: boolean;
  itinerariesItemType: (typeof ITINERARIES_ITEM_TYPES)[keyof typeof ITINERARIES_ITEM_TYPES];
  landingShareUrl: string;
  itemId: string;
  closeModal: () => void;
  showPermissions?: boolean;
  manageHideCosts?: boolean;
  hideHideCosts?: boolean;
};

export function Content(props: ContentProps) {
  const {
    builder,
    itinerariesItemType,
    landingShareUrl,
    itemId,
    closeModal,
    showPermissions,
    manageHideCosts,
    hideHideCosts,
  } = props;

  if (builder) {
    if (itinerariesItemType === ITINERARIES_ITEM_TYPES.GUEST_PORTAL) {
      return (
        <ShareViaEmail
          builder={builder}
          itinerariesItemType={itinerariesItemType}
          closeModal={closeModal}
          itemId={itemId}
        />
      );
    }
    return (
      <Tabs defaultSelected="copy-link" componentsProps={{ wrapper: { className: s.tabs } }} segmented>
        <Tabs.Panel id="copy-link" title="Copy Link">
          <CopyLink
            builder={builder}
            itinerariesItemType={itinerariesItemType}
            link={landingShareUrl}
            itemId={itemId}
            closeModal={closeModal}
          />
        </Tabs.Panel>

        <Tabs.Panel id="share-via-email" title="Share via Email">
          <ShareViaEmail
            builder={builder}
            itinerariesItemType={itinerariesItemType}
            closeModal={closeModal}
            itemId={itemId}
          />
        </Tabs.Panel>
      </Tabs>
    );
  }

  return (
    <>
      <ShareViaEmail
        builder={builder}
        itinerariesItemType={itinerariesItemType}
        closeModal={closeModal}
        itemId={itemId}
        showPermissions={showPermissions}
        manageHideCosts={manageHideCosts}
        hideHideCosts={hideHideCosts}
      />
    </>
  );
}
